import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// import jsPDF from 'jspdf';
// import autoTable from 'jspdf-autotable';

import jsPDF from 'jspdf';
require('jspdf-autotable');

import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

import { SearchResult } from 'src/domain/searchResults/searchResult';
import { map } from 'rxjs/operators';
import { Permits } from 'src/domain/enums/Permits.enum';
import { SaleScope } from 'src/domain/enums/SaleScope.enum';

import { NotificationsService } from './notifications.service';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { environment } from '../../environments/environment';
import { RepairSettings } from 'src/domain/utils/repairSettings';
import { MenuItem } from 'primeng/api';
import { SalesSettings } from 'src/domain/utils/salesSettings';
import { AppSettings } from 'src/domain/utils/appSettings';
import { Observable } from 'rxjs';
import { imagepdf } from 'src/assets/img/logopdf';



declare var require: any;

@Injectable({
  providedIn: "root",
})
export class GlobalService {
  // per servizi


  endpoint = environment.API_URL;
  photoEndpoint = environment.API_PHOTO_URL;

  public overlayLoadingTemplate =
  '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>';
  public overlayNoRowsTemplate =
  '<span class="ag-overlay-loading-center">No results found.</span>';
  public changePasswordMessage:any[]=[];
  // CONFIGURAZIONI
  impostazioni: any = [];
  locale: string;
  decimalSeparator: string;
  workstation: any;
  loggedSocieta: string;
  loggedCdC: string;

  loggedUser:any={};
  loggedUserPassword: string='';

  kpilist: any = [];
  kpilist_hp: any = [];

  
  shops: any[];
  selShop: number;
  userGroup: number;
  activeModules: any[];

  // IMPOSTAZIONI
  appSettings: AppSettings;
  repairSettings: RepairSettings;
  salesSettings: SalesSettings;

  // FILTRI SALVATI
  customerFilters: any;
  companyFilters: any;

  // per abilitazioni
  userGroups: any[];
  userPermits: any[];
  permits: string[] = [];

  calendarLocale: any = {};

  showMenu: boolean = false;

  // GESTIONE TABELLE

  menuItems: MenuItem[];

  labels: any;

  // GESTIONE DIALOG ERRORI
  showErrorDialog: boolean = false;
  sessionescadutamsg="Attenzione, la sessione dell'utente è scaduta. Si prega di effettuare nuovamente il login";
  showErrorDescription=this.sessionescadutamsg;
  // MENU
  openMenu: boolean = false;
  logininfo:any;

  constructor(
    private notificationsService: NotificationsService
  ) {
    

    this.calendarLocale.en = {
      firstDayOfWeek: 0,
      dayNames: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ],
      dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
      monthNames: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      monthNamesShort: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      today: "Today",
      clear: "Clear",
      dateFormat: "mm/dd/yy",
      weekHeader: "Wk",
    };
    this.calendarLocale.it = {
      firstDayOfWeek: 0,
      dayNames: [
        "Domenica",
        "Lunedì",
        "Martedì",
        "Mercoledì",
        "Giovedì",
        "Venerdì",
        "Sabato",
      ],
      dayNamesShort: ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],
      dayNamesMin: ["Do", "Lu", "Ma", "Me", "Gi", "Ve", "Sa"],
      monthNames: [
        "Gennaio",
        "Febbraio",
        "Marzo",
        "Aprile",
        "Maggio",
        "Giugno",
        "Luglio",
        "Agosto",
        "Settembre",
        "Ottobre",
        "Novembre",
        "Dicembre",
      ],
      monthNamesShort: [
        "Gen",
        "Feb",
        "Mar",
        "Apr",
        "Mag",
        "Giu",
        "Lug",
        "Ago",
        "Set",
        "Ott",
        "Nov",
        "Dic",
      ],
      today: "Oggi",
      clear: "svuota",
      dateFormat: "dd/mm/yy",
      weekHeader: "Sett.",
    };

    this.loggedUser=JSON.parse(localStorage.getItem('loggedUser'));
    this.logininfo=JSON.parse(localStorage.getItem('logininfo'));
    if(this.loggedUser){
      this.kpilist=JSON.parse(localStorage.getItem('kpilistv4'+this.loggedUser.id));
    }
   
    if(this.kpilist){
      this.kpilist_hp=this.kpilist.filter(item => item.isprimary ).map(item => {return item});
    }
  
   
  }
  donotif(){
   //this.notificationsService.addMessage('far fa-file-excel', 'File excel in preparazione.', '#FFFADF', new Date());
  }
  
 

  
  // APIs
  getHeaders() {
    return new HttpHeaders({
      "Content-Type": "application/json",
      Authorization:'Bearer ' +  localStorage.getItem("login_token"),
    });
  }

  getTempHeaders() {
    return new HttpHeaders({
      "Content-Type": "application/json",
      Authorization:'Bearer ' +  localStorage.getItem("login_Token"),
    });
  }

  getTempHeader() {
    return new HttpHeaders({
      "Content-Type": "application/json",
      Authorization:'Bearer ' +  localStorage.getItem("sales_token"),
    });
  }

  // EXPORT PDF
  isExporting: boolean = false;
  
  doTable(doc,title:string,header:any,table:any){
    
    doc.autoTable(header,table, {
     
      margin: { horizontal: 10,top:30 },
      styles: { 
        overflow: "linebreak"
      },
      bodyStyles: { valign: "top" },
      headStyles: {
        fillColor: [255, 255, 255],
        textColor: [30, 30, 30],
      },
      columnStyles: { email: { columnWidth: "wrap" } },
      theme: "striped",
      showHead: "everyPage",
      didDrawPage: function (data) {
        
        doc.addImage(imagepdf, 'JPEG', 0, 0, 45, 25);
        // Header
        doc.setFontSize(14);
      //    doc.setTextColor(10);
        doc.text(title, 42, 20);

        doc.setFontSize(16);
        //  doc.setTextColor(10);
      //      //    doc.text('pppp', data.settings.margin.left, 16);
      //  console.log(data);
        // Footer
        var str = "Page " + doc.internal.getNumberOfPages();
    
        doc.setFontSize(10);
    
        // jsPDF 1.4+ uses getWidth, <1.4 uses .width
        var pageSize = doc.internal.pageSize;
        var pageHeight = pageSize.height
          ? pageSize.height
          : pageSize.getHeight();
        doc.text(str, data.settings.margin.left, pageHeight - 10);
      }
    });
  }
  
  print_checklist(data:any,dataUser:any){
    let doc: any = new jsPDF("l", "mm", "a4");

    let title='';
    if((data.model.title)&&(data.model.title.default)){
      title=data.model.title.default;
    }
    if((data.model.title)&&(data.model.title.it)){
      title=data.model.title.it;
    }
    if((data.stat)&&(data.stat.length>0)&&(data.stat[0].struttura)){
      title+=': '+ data.stat[0].struttura;
    }
 
    if(data.lastmodify)
      title+= ' ' + data.lastmodify;
    if((dataUser.Result[0])&&(dataUser.Result[0].label))
      title+= ' utente: ' + dataUser.Result[0].label;
    
    let struttura_id=0;
    data.dati.forEach((d:any)=>{
      struttura_id=d.struttura;
    });
    data.data.forEach((d:any)=>{
     
      d.childs.forEach((r:any)=>{
        let tb=[];
        let header=[];
        header.push(r.question);
        r.childs.forEach((c:any)=>{
          tb.push([c.question]);
          if(c['rsa'+struttura_id]){
            if(c['rsa'+struttura_id]=='dettaglio'){
              let res=c['rsa'+struttura_id+'_more'];
              res=res.split('<table>').join('');
              res=res.split('</table>').join('');
              res=res.split('</tr>').join('');
              res=res.split('<tr>').join('\n');
              tb.push([res]);
            } else {
              tb.push(["Risposta: "+ c['rsa'+struttura_id]]);
            }
        
          } else {
            tb.push(["Risposta: -"]);
          }
          if((data.dati[0])&&(c.id)&&(data.dati[0][c.id+'_attivita'])){
            if(data.dati[0][c.id+'_attivita']['attivita']){
              tb.push(["Attività: "+data.dati[0][c.id+'_attivita']['attivita']]);
            }
            if(data.dati[0][c.id+'_attivita']['tipologia']){
              tb.push(["    Tipologia: "+data.dati[0][c.id+'_attivita']['tipologia']]);
            }
            
            if(data.dati[0][c.id+'_attivita']['argomento']){
              tb.push(["    Argomento: "+data.dati[0][c.id+'_attivita']['argomento']]);
            }

            if(data.dati[0][c.id+'_attivita']['uffprovenienza']){
              tb.push(["    Uff. provenienza: "+data.dati[0][c.id+'_attivita']['uffprovenienza']]);
            }
            if(data.dati[0][c.id+'_attivita']['uffdestinazione']){
              tb.push(["    Uff. destinazione: "+data.dati[0][c.id+'_attivita']['uffdestinazione']]);
            }
            if(data.dati[0][c.id+'_attivita']['testo']){
              tb.push(["    Nota: "+data.dati[0][c.id+'_attivita']['testo']]);
            }
        
          }
        });
        this.doTable(doc,title,header,tb);
      });
    });
    
    doc.save(title+'.pdf');

  }

  exportPdf (filename: string, selColumns: any[], data: any[], columnStyles: any,  header?: string,  footer?: string) {

    return new Promise(resolve => {
      
      setTimeout(()=>{
        let doc: any = new jsPDF("l", "mm", "a4");
        if (header) {
          doc.setFontSize(12);
          doc.text(14, 10, header);
        }
        if (footer) {
          doc.setFontSize(10);
          doc.text(14, 20, footer);
        }
        doc.autoTable(selColumns, data, {
          startY: 30,
          rowPageBreak: 'avoid',
          styles: { cellWidth: "wrap", fontSize: 7, },
          columnStyles: columnStyles,
          willDrawCell: function (tableData) {
            if (tableData.column.dataKey === "proPic") {
              tableData.cell.text = "";
              tableData.cell.contentWidth = 30;
              tableData.cell.width = 30;
              tableData.cell.minReadableWidth = 30;
              tableData.cell.minWidth = 30;
              tableData.cell.wrappedWidth = 30;
              tableData.column.contentWidth = 30;
              tableData.column.width = 30;
              tableData.column.minReadableWidth = 30;
              tableData.column.minWidth = 30;
              tableData.column.wrappedWidth = 30;
            }
          },
          didDrawCell: function (tableData) {
            if (tableData.column.dataKey === "proPic" && tableData.cell.raw) {
              var dim = tableData.cell.height - tableData.cell.padding("vertical");
              var imgData = 'data:image/jpeg;base64,'+ tableData.cell.raw;
              doc.addImage(imgData, 'JPEG', tableData.cell.x, tableData.cell.y+2, 14, 14);
              tableData.cell.text = "";
            }
          },
        });
        doc.save(filename);
        resolve('resolved');
      },3000)
      //this.isExporting = false;
    });
  }

  public toDataURL(url, callback) {
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
      var reader = new FileReader();
      reader.onloadend = function () {
        callback(reader.result);
      };
      reader.readAsDataURL(xhr.response);
    };
    xhr.open("GET", url);
    xhr.responseType = "blob";
    xhr.send();
  }

  // EXPORTO EXCEL
  async exportExcelWorker(exportData: any[], fileName: string) {
    
    this.notificationsService.addMessage('far fa-file-excel', 'File excel in preparazione.','#FFF', '#FFFADF', new Date());
    
    if (typeof Worker !== 'undefined') {
      const worker = new Worker(new URL('../_workers/export.worker', import.meta.url), { type: 'module' });
      worker.onmessage = ({ data }) => {
        var finalFileName = fileName + "_export_" + new Date().getTime();
        this.saveAsExcelFile(data, finalFileName);
        this.notificationsService.addMessage('far fa-file-excel', 'File '+finalFileName+' completato.','#FFF', '#E7FFDF', new Date());
      };
      worker.postMessage(exportData);
    }
  }

  exportExcel(data: any[], fileTitle: string) {
     /*
    return new Promise((resolve) => {
     

      import("xlsx").then((xlsx) => {
        const worksheet = xlsx.utils.json_to_sheet(data);
        const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
        const excelBuffer: any = xlsx.write(workbook, {
          bookType: "xlsx",
          type: "array",
        });
        this.saveAsExcelFile(excelBuffer, fileTitle);
      });
    });
    */
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    /*
    import("file-saver").then((FileSaver) => {
      const EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
    });
    */
  }

  resetService() {
    this.selShop = undefined;
    this.loggedUser = undefined;
    this.workstation = undefined;
    this.loggedSocieta = undefined;
    this.loggedCdC = undefined;
    this.loggedUser = undefined;

  }

  public get aPermits(): typeof Permits {
    return Permits;
  }

  public get saleScope(): typeof SaleScope {
    return SaleScope;
  }

 

  /**
   * Permette di effettuare un "salto" all'elemento interno della pagina HTML.
   * @param element l'elemento HTML al quale saltare. IMPORTANTE: ricorda di creare il riferimento tramite "#element" sull'elemento HTML
   */
  public jumpToElement(element: HTMLElement):void {
    var headerOffset = 100;
    var elementPosition = element.getBoundingClientRect().top;
    var offsetPosition = elementPosition + window.scrollY - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    });
  }
  
  submitForm(action, method, formGroup: any) {
    const form = document.createElement('form');
    form.style.display = 'none';
    form.method = method;
    form.target = '_blank';
    form.action = environment.JAVALOGINURL+action;
    let input;
    for (const [key, value] of Object.entries(formGroup)) {
      input = document.createElement('input');
      input.name = key;
      input.id = key;
      input.value = value;
      form.appendChild(input);
    }
    document.body.appendChild(form);
      form.submit();
  }
}
